import { gql } from "@apollo/client";

export const makesQuery = gql`
  query ($manufacturer: String, $year: Int) {
    rv_makes(manufacturer: $manufacturer, year: $year)
  }
`;
